import styled, { css } from 'styled-components'
import Colors from '../../theme/colors'
import { Sizes } from './Modal'

export const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 1000;
`

export const ModalWrapper = styled.section<{size: Sizes}>`
  position: relative;
  height: auto;
  padding: 56px;
  background: ${Colors.Primary.White};
  box-shadow: 0px 10px 54px rgba(48, 71, 72, 0.15);
  border-radius: 16px;
  width: 551px;
  ${props => props.size === Sizes.small && css`
    height: 300px;
    width: 650px;
  `}
  ${props => props.size === Sizes.medium && css`
    height: 400px;
    width: 750px;
  `}
  ${props => props.size === Sizes.large && css`
    height: 551px;
    width: 910px;
  `}
`

export const CloseButton = styled.div.attrs({
  role: 'button',
  tabIndex: 0,
  'aria-label': 'Sluiten',
})`
  position: absolute;
  padding: 36px;
  right: 0;
  top: 0;
  border: none;
  cursor: pointer;

  svg {
    path {
      fill: ${Colors.Primary.GreyTextLight};
    }
  }
`
